import React from "react";
import { ListGroup, Placeholder } from "react-bootstrap";

const UrgentUpdateSkeleton = () => {
  return Array.from({ length: 3 }).map((_, index) => (
    <ListGroup.Item
      key={index}
      className="d-flex align-items-center border-1 border-light-subtle rounded-4 small"
    >
      {/* Left Side: Title + Subtitle (Full Width) */}
      <div className="flex-grow-1">
        <Placeholder as="div" animation="wave" className="w-100">
          <Placeholder xs={8} className="rounded mb-1" />
          <Placeholder xs={6} className="rounded" />
        </Placeholder>
      </div>

      {/* Right Side: Badge Placeholder */}
      <div className="ms-auto d-flex align-items-center">
        <Placeholder
          //   as="span"
          //   animation="wave"
          className="rounded-pill"
          style={{ width: "70px", height: "20px" }}
        />
      </div>
    </ListGroup.Item>
  ));
};

export default UrgentUpdateSkeleton;
